import { render } from "./label.vue?vue&type=template&id=b2ff7cb0&scoped=true&lang=pug"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"

import "./label.vue?vue&type=style&index=0&id=b2ff7cb0&lang=scss&scoped=true"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ff7cb0"]])

export default __exports__